module.exports = __webpack_public_path__ + "img/9dd1f5b56acc3e744293ee0196fe0dbd.0017303d.png";